import ItemTask from 'containers/Profile/Panels/DocumentManager/ItemTask';
import { PureComponent } from 'react';
import Modal from 'components/Modal';

import { TasksWrapper } from './styles';
import TasksListContainer from 'containers/Tasks/TasksManagement/TasksListContainer';

interface IComponentProps {
  companyId: number;
  providerItemId: number;
  modalTitle: string;
  onCloseContentTasksModal: () => void;
  templateId?: number;
}

interface IComponentStates {
  showTaskEditor: boolean | number;
}

class ContentTasksModal extends PureComponent<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    showTaskEditor: false,
  };

  onCloseTask = () => {
    this.setState((prevState: IComponentStates) => ({
      showTaskEditor: !prevState.showTaskEditor,
    }));
  };

  handleShowTaskEditor = (taskId?: number | 'new') => {
    // if taskId is not exist we should show a task editor for new task creation
    this.setState({
      showTaskEditor: taskId ? (taskId as number) : true,
    });
  };

  handleHideTaskEditor = () => {
    this.setState({ showTaskEditor: false });
  };

  render() {
    const {
      companyId,
      providerItemId,
      modalTitle,
      onCloseContentTasksModal,
      templateId,
    } = this.props;
    return (
      <Modal
        width="90%"
        title={modalTitle}
        onClose={onCloseContentTasksModal}
        isActive={true}
      >
        <TasksWrapper>
          <TasksListContainer
            companyId={companyId}
            providerItemId={providerItemId}
            onOpenTaskEditor={this.handleShowTaskEditor}
            withFewerOptions={true}
            templateId={templateId}
          />
          {this.state.showTaskEditor && (
            <ItemTask
              companyId={companyId}
              onClose={this.handleHideTaskEditor}
              tab="info"
              taskId={
                typeof this.state.showTaskEditor === 'number'
                  ? this.state.showTaskEditor
                  : 0
              }
            />
          )}
        </TasksWrapper>
      </Modal>
    );
  }
}

export default ContentTasksModal;
